import { useLocal } from "../../util/local.ts";

// Phase 8b: a lightweight play-by-play feed of the game the host is watching
// live. The host plays the game in BBGM's normal LiveGame; each revealed play
// is broadcast here so everyone else follows along in real time. Ephemeral.
const MpLivePlayByPlay = () => {
	const { mpLiveGame } = useLocal(["mpLiveGame"]);

	if (!mpLiveGame) {
		return null;
	}

	const [t0, t1] = mpLiveGame.teams;
	const latest = mpLiveGame.plays.at(-1);
	const score = latest?.score ?? [0, 0];

	// Playoff series standing going into this game (issue: spectators could see
	// game scores but not their record in the series)
	const series = mpLiveGame.series;
	let seriesText: string | undefined;
	if (series) {
		const [w0, w1] = series.won;
		if (w0 === w1) {
			seriesText = `Series tied ${w0}-${w1}`;
		} else {
			const leader = w0 > w1 ? t0 : t1;
			const hi = Math.max(w0, w1);
			const lo = Math.min(w0, w1);
			const clinched = hi >= series.target;
			seriesText = clinched
				? `${leader.region} win series ${hi}-${lo}`
				: `${leader.region} lead series ${hi}-${lo}`;
		}
	}

	return (
		<div className="card mb-3 border-danger" style={{ maxWidth: 720 }}>
			<div className="card-body">
				<h2 className="card-title d-flex align-items-center gap-2">
					<span className="badge text-bg-danger">● LIVE</span>
					<span>
						{t0.abbrev} {score[0]} - {score[1]} {t1.abbrev}
					</span>
					{mpLiveGame.ended ? (
						<span className="badge text-bg-secondary">Final</span>
					) : null}
				</h2>
				{seriesText ? (
					<p className="mb-1 fw-bold text-body-secondary">
						{seriesText}
						{series ? (
							<span className="fw-normal"> (first to {series.target})</span>
						) : null}
					</p>
				) : null}
				<p className="text-body-secondary">
					{mpLiveGame.ended
						? "The host finished this game."
						: `The host is watching ${t0.region} vs ${t1.region} play-by-play - plays appear here as they happen.`}
				</p>
				{mpLiveGame.plays.length === 0 ? (
					<p className="text-body-secondary mb-0">Tip off...</p>
				) : (
					<div style={{ maxHeight: 320, overflowY: "auto" }}>
						{mpLiveGame.plays
							.map((p, i) => ({ p, i }))
							.reverse()
							.map(({ p, i }) => (
								<div
									key={i}
									className="d-flex gap-2 border-bottom py-1 align-items-baseline"
								>
									{p.time ? (
										<span
											className="text-body-secondary small"
											style={{ minWidth: 44 }}
										>
											{p.time}
										</span>
									) : null}
									<span className="flex-grow-1">{p.text}</span>
									<span className="text-body-secondary small">
										{p.score[0]}-{p.score[1]}
									</span>
								</div>
							))}
					</div>
				)}
			</div>
		</div>
	);
};

export default MpLivePlayByPlay;
